import { createFileRoute } from '@tanstack/react-router';
import { FormPreviewPage } from '../pages';

export interface SearchParams {
  companyId?: string;
  formId?: string;
  packetId?: string;
  templateId?: string;
}

export const Route = createFileRoute('/form-preview')({
  component: FormPreviewPage,
  validateSearch: (search: SearchParams): SearchParams => {
    return search;
  },
});
